import React, { useEffect, useRef, useState } from 'react';
import * as Popover from '@radix-ui/react-popover';
import * as Portal from '@radix-ui/react-portal';
import { AiOutlineClose } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import {
  addComment,
  resetActiveEntityId,
  selectActiveEntityId,
  setActiveEntityId,
} from '../../redux/notesetting/notesSettingsSlice';
import ExternalComment from './ExternalComment';
import ExternalNoteForm from './ExternalNoteForm';
import { Modal } from 'antd';

const ExternalNote = ({ note, setCommentsData, workflowContactId, imageData }) => {

  const { id, coords, comments, targetSelector } = note;
  const dispatch = useDispatch();
  const activeNoteId = useSelector(selectActiveEntityId);

  const [isDirty, setIsDirty] = useState(false);
  const [forceOpen, setForceOpen] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const popoverRef = useRef(null);
  const triggerRef = useRef(null);

  // Handle outside clicks
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('.note-container')) return;
      if (popoverRef.current && !popoverRef.current.contains(event.target) && isDirty && forceOpen) {
        event.preventDefault();
        event.stopPropagation();
        setShowWarningModal(true);
      }
    };

    if (forceOpen && isDirty) {
      document.addEventListener('mousedown', handleClickOutside, true);
      return () => document.removeEventListener('mousedown', handleClickOutside, true);
    }
  }, [isDirty, forceOpen]);

  const handlePopoverChange = (isOpen) => {
    if (!isOpen && isDirty) {
      setShowWarningModal(true);
      return;
    }
    setForceOpen(isOpen);
    if (isOpen) {
      dispatch(setActiveEntityId(id));
    } else {
      dispatch(resetActiveEntityId());
    }
  };

  const handleDiscardConfirm = () => {
    setIsDirty(false);
    setForceOpen(false);
    setShowWarningModal(false);
    dispatch(resetActiveEntityId());
  };

  const handleDiscardCancel = () => setShowWarningModal(false);

  const handleCloseClick = (e) => {
    if (isDirty) {
      e.preventDefault();
      setShowWarningModal(true);
      return;
    }
    setForceOpen(false);
    dispatch(resetActiveEntityId());
  };

  return (
    <>
      <Popover.Root open={forceOpen} onOpenChange={handlePopoverChange} modal={true}>
        <Portal.Root
          className="note"
          container={document.querySelector(targetSelector)}
          style={{
            transform: `translate3d(${coords.x.size + coords.x.unit}, ${coords.y.size + coords.y.unit}, 0)`,
          }}
        >
          <Popover.Trigger ref={triggerRef} className="note-pin pin" />
        </Portal.Root>

        <Popover.Portal>
          <Popover.Content ref={popoverRef} className="note-container" side="right" sideOffset={20}>
            <div className="note-header">
              <div className="buttons">
                <Popover.Close className="note-icons-btn cursor-pointer" onClick={handleCloseClick}>
                  <AiOutlineClose />
                </Popover.Close>
              </div>
            </div>

            <div className="comments-container">
              {Array.isArray(comments) &&
                comments.map((comment) => (
                  <ExternalComment
                    key={comment.id}
                    workflowContactId={workflowContactId}
                    commentDetails={comment}
                    alreadyExists={setCommentsData}
                    imageData={imageData}
                  />
                ))}
            </div>

            <div className="custom-get-review-image-form form-container">
              <img src={require('../../static/img/No_image_available.png')} alt="" />
              <ExternalNoteForm
                note={note}
                workflowContactId={workflowContactId}
                noteId={activeNoteId}
                imageData={imageData}
                onDirtyChange={setIsDirty}
                onCommentAdded={() => {
                  setForceOpen(false);
                  dispatch(resetActiveEntityId());
                }}
              />
            </div>
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>

      <Modal
        title="Discard Comment"
        open={showWarningModal}
        onOk={handleDiscardConfirm}
        onCancel={handleDiscardCancel}
        okText="Continue"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
      >
        <p>The comment will be discarded. Do you want to continue?</p>
      </Modal>
    </>
  );
};

export default ExternalNote;
